import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Observable, ReplaySubject } from 'rxjs';

import { WINDOW } from '@app/common/tokens/window.token';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private window = inject<Window>(WINDOW);

  SCROLL_EVENT_BUS: Observable<string>;

  private readonly isPlatformBrowser: boolean;
  private _scrollEventBus = new ReplaySubject<string>(1);

  constructor() {
    const platformId = inject(PLATFORM_ID);

    this.isPlatformBrowser = isPlatformBrowser(platformId);
    this.SCROLL_EVENT_BUS = this._scrollEventBus.asObservable();
  }

  requestScrollToElement(elementId: string): void {
    this._scrollEventBus.next(elementId);
  }

  resetScrollRequest(): void {
    this._scrollEventBus.next(null);
  }

  scrollToTop(): void {
    if (!this.isPlatformBrowser) {
      return;
    }

    this.window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollToElement(elementId: string): void {
    if (!this.isPlatformBrowser) {
      return;
    }

    const element = document.getElementById(elementId);
    if (!element) {
      return;
    }

    const header = document.getElementById('header');
    const scrollCorrection = header ? header.getBoundingClientRect().height : 0;

    this.window.scrollBy({ top: element.getBoundingClientRect().top - scrollCorrection, behavior: 'smooth' });
  }
}
